import { useNavigate } from 'react-router-dom';
import { auth } from '../../../firebaseConfig';
import { useAuth } from '../../../contexts/AuthContext';

export default function AdminDashboard() {
    const navigate = useNavigate();
    const { user } = useAuth();

    const handleLogout = async () => {
        try {
            await auth.signOut();
            navigate('/login');
        } catch (error) {
            console.error("Error signing out: ", error);
        }
    };

    return (
        <div className="min-h-screen bg-gray-50">
            <header className="bg-white shadow-sm">
                <div className="max-w-7xl mx-auto px-4 py-4 flex justify-between items-center">
                    <h1 className="text-xl font-bold text-gray-800">管理者ダッシュボード</h1>
                    <div className="flex items-center gap-4">
                        <span className="text-sm text-gray-600">{user?.email || user?.phoneNumber}</span>
                        <button
                            onClick={handleLogout}
                            className="text-sm text-red-600 hover:text-red-800 cursor-pointer"
                        >
                            ログアウト
                        </button>
                    </div>
                </div>
            </header>

            <main className="max-w-7xl mx-auto px-4 py-8">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                    {/* Shikaku Management Card */}
                    <div
                        onClick={() => navigate('/admin/shikaku')}
                        className="bg-white p-6 rounded-xl shadow-sm hover:shadow-md transition-all cursor-pointer border border-gray-100"
                    >
                        <div className="flex items-center gap-4 mb-4">
                            <div className="w-12 h-12 bg-blue-100 rounded-lg flex items-center justify-center">
                                <i className="ri-book-mark-line text-blue-600 text-2xl"></i>
                            </div>
                            <h2 className="text-lg font-bold text-gray-800">資格管理</h2>
                        </div>
                        <p className="text-gray-600 text-sm">資格情報の追加、編集、削除を行います。</p>
                    </div>

                    {/* AnswerSheet Management Card */}
                    <div
                        onClick={() => navigate('/admin/answers')}
                        className="bg-white p-6 rounded-xl shadow-sm hover:shadow-md transition-all cursor-pointer border border-gray-100"
                    >
                        <div className="flex items-center gap-4 mb-4">
                            <div className="w-12 h-12 bg-green-100 rounded-lg flex items-center justify-center">
                                <i className="ri-file-list-3-line text-green-600 text-2xl"></i>
                            </div>
                            <h2 className="text-lg font-bold text-gray-800">回答結果管理</h2>
                        </div>
                        <p className="text-gray-600 text-sm">ユーザーの試験結果を確認、削除します。</p>
                    </div>

                    {/* User Management Card */}
                    <div
                        onClick={() => navigate('/admin/users')}
                        className="bg-white p-6 rounded-xl shadow-sm hover:shadow-md transition-all cursor-pointer border border-gray-100"
                    >
                        <div className="flex items-center gap-4 mb-4">
                            <div className="w-12 h-12 bg-purple-100 rounded-lg flex items-center justify-center">
                                <i className="ri-user-settings-line text-purple-600 text-2xl"></i>
                            </div>
                            <h2 className="text-lg font-bold text-gray-800">ユーザー管理</h2>
                        </div>
                        <p className="text-gray-600 text-sm">登録ユーザーの一覧表示と管理を行います。</p>
                    </div>

                    {/* Questions Management Card */}
                    <div
                        onClick={() => navigate('/admin/questions')}
                        className="bg-white p-6 rounded-xl shadow-sm hover:shadow-md transition-all cursor-pointer border border-gray-100"
                    >
                        <div className="flex items-center gap-4 mb-4">
                            <div className="w-12 h-12 bg-orange-100 rounded-lg flex items-center justify-center">
                                <i className="ri-question-answer-line text-orange-600 text-2xl"></i>
                            </div>
                            <h2 className="text-lg font-bold text-gray-800">問題管理</h2>
                        </div>
                        <p className="text-gray-600 text-sm">資格試験の問題を追加、編集、削除を行います。</p>
                    </div>

                    {/* Order Management Card */}
                    <div
                        onClick={() => navigate('/admin/orders')}
                        className="bg-white p-6 rounded-xl shadow-sm hover:shadow-md transition-all cursor-pointer border border-gray-100"
                    >
                        <div className="flex items-center gap-4 mb-4">
                            <div className="w-12 h-12 bg-pink-100 rounded-lg flex items-center justify-center">
                                <i className="ri-shopping-cart-line text-pink-600 text-2xl"></i>
                            </div>
                            <h2 className="text-lg font-bold text-gray-800">Order管理</h2>
                        </div>
                        <p className="text-gray-600 text-sm">ユーザーと資格の紐付けを管理します。</p>
                    </div>

                    {/* Information Management Card */}
                    <div
                        onClick={() => navigate('/admin/information')}
                        className="bg-white p-6 rounded-xl shadow-sm hover:shadow-md transition-all cursor-pointer border border-gray-100"
                    >
                        <div className="flex items-center gap-4 mb-4">
                            <div className="w-12 h-12 bg-yellow-100 rounded-lg flex items-center justify-center">
                                <i className="ri-notification-3-line text-yellow-600 text-2xl"></i>
                            </div>
                            <h2 className="text-lg font-bold text-gray-800">お知らせ管理</h2>
                        </div>
                        <p className="text-gray-600 text-sm">お知らせの追加、編集、削除を行います。</p>
                    </div>
                </div>
            </main>
        </div>
    );
}
